/**
 * Filter popout (top right, funnel button): aircraft-type filters,
 * hide-ground toggle, ground-position dots, trails, the altitude range
 * (min–max dual slider) and the search radius.
 */
const ALT_MAX = 12000; // Slider-Endwert = "unbegrenzt"

export function setupFilterPanel(flightManager, flightService) {
  const panel = document.getElementById('filterPanel');
  const toggle = document.getElementById('filterToggle');
  const badge = document.getElementById('filterBadge');
  const controlsPanel = document.getElementById('controlsPanel');

  // --- Panel öffnen/schließen ----------------------------------------------
  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    controlsPanel.classList.remove('open'); // nie beide Popouts gleichzeitig
    panel.classList.toggle('open');
    toggle.classList.toggle('active', panel.classList.contains('open'));
  });

  document.addEventListener('pointerdown', (e) => {
    if (panel.classList.contains('open') &&
        !panel.contains(e.target) && !toggle.contains(e.target)) {
      panel.classList.remove('open');
      toggle.classList.remove('active');
    }
  });

  // --- Flugzeugtyp-Filter ---------------------------------------------------
  const typeButtons = panel.querySelectorAll('.tb-btn[data-type]');
  typeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const active = !btn.classList.contains('active');
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', String(active));

      const types = { ...flightManager.filters.types, [btn.dataset.type]: active };
      flightManager.setFilters({ types });
      updateBadge();
    });
  });

  // --- Bodenverkehr ausblenden ---------------------------------------------
  const hideGround = document.getElementById('hideGround');
  hideGround.addEventListener('change', () => {
    flightManager.setFilters({ hideGround: hideGround.checked });
  });

  // --- Bodenpunkte / Flugspuren --------------------------------------------
  const groundDots = document.getElementById('toggleGroundDots');
  groundDots.addEventListener('change', () => {
    flightManager.setFilters({ showGroundDots: groundDots.checked });
  });

  const trails = document.getElementById('toggleTrails');
  trails.addEventListener('change', () => {
    flightManager.setFilters({ showTrails: trails.checked });
  });

  // --- Höhenbereich (Dual-Slider min–max) ------------------------------------
  const minInput = document.getElementById('minAltitude');
  const maxInput = document.getElementById('maxAltitude');
  const fill = document.getElementById('altRangeFill');
  const valueLabel = document.getElementById('altRangeValue');

  const fmt = (m) => m >= 1000 ? `${(m / 1000).toLocaleString('de-DE')} km` : `${m} m`;

  // Filter-Anwendung entkoppeln: während des Ziehens nur die UI aktualisieren,
  // die (teurere) Neubewertung aller Flüge leicht verzögert nachziehen
  let applyTimer = null;
  function applyFilters() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(() => {
      const min = parseInt(minInput.value, 10);
      const max = parseInt(maxInput.value, 10);
      flightManager.setFilters({
        minAltitude: min,
        maxAltitude: max >= ALT_MAX ? Infinity : max
      });
    }, 120);
  }

  function updateRangeUI(movedInput) {
    let min = parseInt(minInput.value, 10);
    let max = parseInt(maxInput.value, 10);

    // Griffe dürfen sich nicht kreuzen — der bewegte Griff schiebt nicht durch
    if (min > max) {
      if (movedInput === minInput) {
        min = max;
        minInput.value = String(min);
      } else {
        max = min;
        maxInput.value = String(max);
      }
    }

    fill.style.left = `${(min / ALT_MAX) * 100}%`;
    fill.style.right = `${100 - (max / ALT_MAX) * 100}%`;

    if (min === 0 && max >= ALT_MAX) {
      valueLabel.textContent = 'alle Höhen';
    } else if (max >= ALT_MAX) {
      valueLabel.textContent = `ab ${fmt(min)}`;
    } else if (min === 0) {
      valueLabel.textContent = `bis ${fmt(max)}`;
    } else {
      valueLabel.textContent = `${fmt(min)} – ${fmt(max)}`;
    }

    updateBadge();
    applyFilters();
  }

  minInput.addEventListener('input', () => updateRangeUI(minInput));
  maxInput.addEventListener('input', () => updateRangeUI(maxInput));

  // --- Suchradius (km) -------------------------------------------------------
  const radiusSlider = document.getElementById('radiusSlider');
  const radiusValue = document.getElementById('radiusValue');
  radiusSlider.addEventListener('input', () => {
    radiusValue.textContent = radiusSlider.value;
    // Ring live mitziehen, während geschoben wird
    flightManager.setRadiusKm(parseInt(radiusSlider.value, 10));
  });
  radiusSlider.addEventListener('change', () => {
    const value = parseInt(radiusSlider.value, 10);
    flightService.setRadius(value);
    flightManager.setRadiusKm(value);
  });

  // --- Badge am Filter-Button, sobald ein Filter aktiv ist -------------------
  function updateBadge() {
    const typesOff = [...typeButtons].some((b) => !b.classList.contains('active'));
    const altActive = parseInt(minInput.value, 10) > 0 || parseInt(maxInput.value, 10) < ALT_MAX;
    badge.classList.toggle('hidden', !(typesOff || altActive));
  }

  updateRangeUI(minInput);
}
